import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

export default function RecommendedComics() {
  const recommended = comics.filter((c) => c.isRecommended);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              编辑精选
            </h2>
            <p className="text-sm text-foreground-600 mt-2">精心挑选的高品质韩漫佳作</p>
          </div>
          <a href="/category/fantasy" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {recommended.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}